// import { useEffect, useState,type ComponentType,} from "react";
// import { useNavigate } from "react-router-dom";

// import { HOST_TOKEN } from "../config/token";

// type RemoteComponent = ComponentType<Record<string, unknown>>;
// type UseLoginReturn = {
//   email: string;
//   setEmail: (value: string) => void;
//   handleSubmit: () => Promise<void>;
//   isValid: boolean;
//   Button: RemoteComponent | null;
//   Input: RemoteComponent | null;
//   loading: boolean;
// };

// export default function useLogin():
// UseLoginReturn {

//   const [email, setEmail] = useState("");
//   const [Button, setButton] =
//   useState<RemoteComponent | null>(
//     null
//   );

//   const [Input, setInput] =
//   useState<RemoteComponent | null>(
//     null
//   );

//   const navigate = useNavigate();

//   useEffect(() => {
//     import("remote_app/Button").then((mod) => {
//       setButton(
//   () => mod.default as RemoteComponent
//   );
//     });

//     import("inputfield/Input").then((mod) => {
//        setInput(
//        () => mod.default as RemoteComponent
//          );    });
//       }, []);

//   const handleSubmit = async () => {
//     try {
//       const authService =
//         (await import("service1/authService")).default;

//       const data = await authService.login(
//         { email },
//         HOST_TOKEN
//       );

//       if (data.statusType === 1) {
//         sessionStorage.setItem(
//           "userId",
//           data.userId || ""
//         );

//         navigate("/password", {
//           state: { name: data.name },
//         });
//       } else {
//         sessionStorage.setItem(
//           "invalidEmail",
//           email
//         );

//         navigate("/not-found");
//       }
//     } catch (err) {
//       console.error("API Error:", err);
//     }
//   };

//   return {
//     email,
//     setEmail,
//     handleSubmit,
//     isValid: email.includes("@"),
//     Button,
//     Input,
//     loading: !Button || !Input,
//   };
// }







import {
  useEffect,
  useState,
  type ComponentType,
} from "react";
import { useNavigate } from "react-router-dom";

// import { HOST_TOKEN } from "../config/token";

type RemoteComponent =
  ComponentType<Record<string, unknown>>;

type UseLoginReturn = {
  email: string;
  setEmail: (value: string) => void;
  handleSubmit: () => Promise<void>;
  isValid: boolean;
  Button: RemoteComponent | null;
  Input: RemoteComponent | null;
  loading: boolean;
  submitting: boolean;
  authToken: string;
};

export default function useLogin(): UseLoginReturn {
  const [email, setEmail] = useState("");

  const [Button, setButton] =
    useState<RemoteComponent | null>(null);

  const [Input, setInput] =
    useState<RemoteComponent | null>(null);

  const [validating, setValidating] =
    useState(true);

  const [authorized, setAuthorized] =
    useState(false);

  const [submitting, setSubmitting] =
    useState(false);

  const [authToken, setAuthToken] =
    useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const initialize = async () => {
      try {
        const token =
          sessionStorage.getItem("AUTH_TOKEN");

        const type =
          sessionStorage.getItem("AUTH_TYPE");

        if (!token || !type) {
          navigate("/", { replace: true });
          return;
        }

        setAuthToken(token);

        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/api/amibit/fwp/validate`,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify({
              token,
              type: Number(type),
            }),
          }
        );

        if (!response.ok) {
          throw new Error(
            `Validation failed: ${response.status}`
          );
        }

        const data = await response.json();

        if (!data.success) {
          navigate("/", { replace: true });
          return;
        }

        setAuthorized(true);

        const buttonModule =
          await import("remote_app/Button");

        const inputModule =
          await import("inputfield/Input");

        setButton(
          () =>
            buttonModule.default as RemoteComponent
        );

        setInput(
          () =>
            inputModule.default as RemoteComponent
        );
      } catch (error) {
        console.error(
          "Token validation error:",
          error
        );

        navigate("/", { replace: true });
      } finally {
        setValidating(false);
      }
    };

    initialize();
  }, [navigate]);

  const handleSubmit = async () => {
    if (submitting) return;

    setSubmitting(true);

    try {
      const authService =
        (
          await import(
            "service1/authService"
          )
        ).default;

     const token =
  sessionStorage.getItem(
    "AUTH_TOKEN"
  ) || "";

const data =
  await authService.login(
    { email },
    token
  );

      if (data.statusType === 1) {
        sessionStorage.setItem(
          "userId",
          data.userId || ""
        );

        setTimeout(() => {
          navigate("/password", {
            state: {
              name: data.name,
            },
          });
        }, 500);
      } else {
        sessionStorage.setItem(
          "invalidEmail",
          email
        );

        setTimeout(() => {
          navigate("/not-found");
        }, 500);
      }
    } catch (err) {
      console.error("API Error:", err);
    } finally {
      setSubmitting(false);
    }
  };

  return {
    email,
    setEmail,
    handleSubmit,
    isValid: email.includes("@"),
    Button,
    Input,
    authToken,
    submitting,
    loading:
      validating ||
      !authorized ||
      !Button ||
      !Input,
  };
}